module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "calibre9"
  }, [_c('table', {
    staticClass: "calibre10",
    attrs: {
      "border": "0",
      "cellspacing": "10",
      "summary": "contents",
      "width": "600"
    }
  }, [_c('tbody', {
    staticClass: "calibre11"
  }, [_c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#BOOK_ONE"
    }
  }, [_vm._v("BOOK ONE : DAWN")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#CHAPTER_1"
    }
  }, [_vm._v("Arisia and Eddore")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#CHAPTER_2"
    }
  }, [_vm._v("The Fall of Atlantis")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#CHAPTER_3"
    }
  }, [_vm._v("The Fall of Rome")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006#BOOK_TWO",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOOK TWO : THE WORLD WAR")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006#CHAPTER_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1918")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007#CHAPTER_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1941")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#CHAPTER_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19—?")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#BOOK_THREE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOOK THREE: TRIPLANETARY")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#CHAPTER_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pirates of Space")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#CHAPTER_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Roger's Planetoid")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#CHAPTER_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fleet Against Planetoid")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#CHAPTER_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Within the Red Veil")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#CHAPTER_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nevian Strife")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#CHAPTER_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worm, Submarine, and Freedom")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#CHAPTER_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hill")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#CHAPTER_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Super-Ship Is Launched")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#CHAPTER_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Specimens")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#CHAPTER_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super-Ship in Action")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#CHAPTER_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roger Carries On")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#CHAPTER_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Specimens Escape")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre15"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#CHAPTER_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giants Meet")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre16",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0